// 项目管理
const CrmProjectManagement = () =>
  import("@/pages/project/crmProjectManagement.vue");
// 会员管理
const MemberProject = () => import("@/pages/project/memberProject.vue");

const arr = [
  // 项目管理
  {
    path: "/project/crmProjectManagement",
    name: "crmProjectManagement",
    component: CrmProjectManagement,
    meta: {
      auth: false,
    },
  },
  // 会员管理
  {
    path: "/project/memberProject",
    name: "memberProject",
    component: MemberProject,
    meta: {
      auth: false,
    },
  },
];

export default arr;
